import React from 'react';
import ReactDOM from 'react-dom/client';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AwardToastProvider } from './contexts/AwardToastContext';
import { AudioPlayerProvider } from './contexts/AudioPlayerContext';
import './styles/index.css';
import './styles/tailwind.css';

// Ensure DOM is fully loaded before rendering
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}

function initializeApp() {
  try {
    const root = ReactDOM?.createRoot(document.getElementById('root'));
    
    root.render(
      <React.StrictMode>
        <ThemeProvider>
          <AuthProvider>
            <AwardToastProvider>
              <AudioPlayerProvider>
                <Routes />
              </AudioPlayerProvider>
            </AwardToastProvider>
          </AuthProvider>
        </ThemeProvider>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Failed to initialize app:', error);
    
    // Fallback UI for initialization errors
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="
          min-height: 100vh; 
          display: flex; 
          flex-direction: column; 
          align-items: center; 
          justify-content: center; 
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          font-family: system-ui, -apple-system, sans-serif;
          color: white;
          text-align: center;
          padding: 20px;
        ">
          <div style="
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border-radius: 12px;
            padding: 2rem;
            border: 1px solid rgba(255, 255, 255, 0.2);
            max-width: 400px;
            width: 100%;
          ">
            <h1 style="margin: 0 0 1rem 0; font-size: 2rem; font-weight: bold;">Application Error</h1>
            <p style="margin: 0 0 1rem 0; opacity: 0.9;">
              The authentication service failed to initialize. Please refresh the page and try again.
            </p>
            <button 
              onClick="window.location.reload()" 
              style="
                background: #4f46e5;
                border: none;
                color: white;
                padding: 0.75rem 1.5rem;
                border-radius: 6px;
                font-weight: 500;
                cursor: pointer;
                transition: all 0.2s;
              "
              onMouseOver="this.style.background='#4338ca'"
              onMouseOut="this.style.background='#4f46e5'"
            >
              Refresh Page
            </button>
          </div>
        </div>
      `;
    }
  }
}